<template>
  <div class="aiaibot-html-widget">
    <AiaiBotMessageHeader
      v-if="!hideHeader"
      :date="date"
      :is-outgoing="isOutgoing"
      :customer-name="customerName"
      :agent-name="agentName"
    />
    <div
      :class="[
        'aiaibot-content tw-p-4',
        isOutgoing
          ? 'tw-rounded-t-lg tw-rounded-l-lg tw-bg-green-light-25'
          : 'tw-rounded-t-lg tw-rounded-r-lg tw-bg-white'
      ]"
      v-html="localMessage"
    ></div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import AiaiBotMessageHeader from './AiaiBotMessageHeader.vue'

export default {
  name: 'AiaiBotHTMLMessage',
  components: {
    AiaiBotMessageHeader
  },
  props: {
    date: {
      type: Date
    },
    message: {
      type: String,
      default: ''
    },
    isOutgoing: {
      type: Boolean
    },
    customerName: {
      type: String,
      default: ''
    },
    hideHeader: {
      type: Boolean
    },
    agentName: {
      type: String,
      default: ''
    }
  },
  setup (props) {
    const localMessage = ref(props.message)
    const linkRegex = new RegExp(/<a[^>]*href="([^"]+)"/gmi)
    const linkMatches = props.message.match(linkRegex) || []
    linkMatches.forEach(link => {
      if (!link.includes('/dl/')) {
        let linkReplace = link.replace('<a', '<a target="_blank"')
        localMessage.value = localMessage.value.replace(link, linkReplace)
      }
    })

    return {
      localMessage
    }
  }
}
</script>

<style scoped lang="postcss">
.aiaibot-html-widget {
  flex: 1;
}

/deep/ .aiaibot-content p {
  @apply tw-text-14 tw-text-black;
}
/deep/ .aiaibot-content a {
  @apply tw-text-14 tw-underline;
}
</style>
